import Typography from "aldoo-ra/Typography"

// Feature Card Component
const FeatureCard = (props) => {
  const { label, description, image, link, addOn } = props
  return (
    <div className="relative group">
      <a
        href={link && link.length > 0 ? (link[0].url || link[0].content?.url) : "#"}
        className="block rounded-2xl transform transition-all duration-200"
      >
        <div className="flex flex-col items-center text-center p-6">
          <div className="w-32 h-32 mb-1 rounded-3xl bg-gradient-to-b from-admin_primary_lt to-admin_primary_dk flex items-center justify-center">
            <img
              src={image}
              alt={label}
              className="w-16 h-16 object-contain filter brightness-0 invert"
            />
          </div>

          <Typography
            variant="admin_body"
            className="font-medium"
          >
            {label}
          </Typography>
        </div>
      </a>

      {description && (
        <div className="absolute invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-200 bottom-full left-1/2 transform -translate-x-1/2 -mb-2 w-64 p-3 bg-admin_info_bg text-admin_text/80 text-sm text-center rounded-lg z-10">
          {description}
          {/* Triangle pointer */}
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-admin_info_bg"></div>
        </div>
      )}
      {addOn && addOn()}
    </div>
  )
}

export default FeatureCard